import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import type { BadgeVariant } from '@property.com.au/ui-kit';
import { BadgeWithStatus } from '@property.com.au/ui-kit';
import { StyledQuestionTooltip } from '../../app-kit/components/StyledQuestionTooltip/StyledQuestionTooltip';

const PropertyStatusContainer = styled.div`
  display: flex;
  align-items: center;
`;

export interface Badge {
  text: string;
  variant: BadgeVariant;
}

interface PropertyStatusProps {
  badge: Badge;
  inPageSource: string;
  tooltip?: string | null;
}

export const PropertyStatus: FunctionComponent<PropertyStatusProps> = ({
  badge,
  tooltip,
  inPageSource,
}) => {
  return (
    <PropertyStatusContainer>
      {badge && <BadgeWithStatus variant={badge.variant}>{badge.text}</BadgeWithStatus>}
      {tooltip && (
        <StyledQuestionTooltip inPageSource={`${inPageSource}_disclaimer`} narrow>
          {tooltip}
        </StyledQuestionTooltip>
      )}
    </PropertyStatusContainer>
  );
};
